import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

//estilos 
import './assets/css/default.css';
import './assets/css/calendar.css';
import './assets/css/sizesAndColors.css';
import '@xyflow/react/dist/style.css';
import "bootstrap/dist/css/bootstrap.css";
import "./assets/css/relatorios.css";
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'moment/locale/pt-br';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
